/**
 * @func validatePassword
 * @param {string} value - The string to validate.
 * @return {boolean}
 * @desc Checks that the password contains at least 8 characters and 1 number.
 * ```js
 * validatePassword('password1');
 * // returns true
 * ```
 * @memberof module:Validators
 * @instance
 */
function validatePassword(value) {
    return value.length >= 8 && !!value.match(/\d/);
}

export { validatePassword as default };
